/**
 * CSS-built recreation of the Owens Corning Platinum Preferred Contractor
 * 2025 award badges (Top Performer · Volume / MVP / Platinum Warranty).
 *
 * These replace low-resolution screenshot uploads where OCR text was mangled.
 */

const RED = "#DC1F2D";

const variants = {
  volume: { headline: "Top Performer", sub: "Volume", showSub: true },
  mvp: { headline: "Top Performer", sub: "MVP", showSub: true, mvpStyle: true },
  warranty: { headline: "Top Performer", sub: "Platinum Warranty", showSub: true },
};

export const AwardBadge = ({ variant = "volume", className = "" }) => {
  const v = variants[variant] || variants.volume;
  return (
    <div
      data-testid={`award-badge-${variant}`}
      className={`relative inline-flex select-none ${className}`}
      style={{ filter: "drop-shadow(0 6px 20px rgba(0,0,0,0.45))" }}
    >
      {/* Outer white rounded border */}
      <div className="bg-white rounded-md flex items-stretch px-2 py-1 gap-1">
        {/* Vertical 2025 */}
        <div
          className="font-display font-black text-slate-900 leading-none flex items-center justify-center"
          style={{
            writingMode: "vertical-rl",
            transform: "rotate(180deg)",
            fontSize: "26px",
            letterSpacing: "0.05em",
          }}
        >
          2025
        </div>

        {/* Right stack */}
        <div className="flex flex-col gap-0.5 min-w-[230px]">
          {/* Top row: OC red square + Platinum Preferred Contractor */}
          <div className="flex items-stretch h-[44px]">
            <div
              className="flex items-center justify-center px-1.5"
              style={{ background: RED, minWidth: 44 }}
            >
              <div className="flex flex-col items-center leading-[1.05] text-white">
                <span className="font-display font-bold text-[9px] uppercase tracking-tight">
                  Owens
                </span>
                <span className="font-display font-bold text-[9px] uppercase tracking-tight">
                  Corning
                </span>
              </div>
            </div>
            <div className="flex-1 bg-slate-300 flex flex-col justify-center px-2">
              <div className="font-fancy font-bold text-slate-900 text-[15px] leading-none tracking-wide">
                PLATINUM
              </div>
              <div className="font-display font-bold text-slate-700 text-[8px] uppercase tracking-[0.05em] mt-0.5">
                Preferred Contractor
              </div>
            </div>
          </div>

          {/* Pink "TOP PERFORMER" band */}
          <div
            className="font-display font-black text-white uppercase tracking-tight text-center py-2"
            style={{ background: "#E91E63", fontSize: "20px", lineHeight: 1 }}
          >
            {v.headline}
          </div>

          {/* Sub label */}
          {v.showSub && (
            <div
              className={`font-display font-bold uppercase text-center text-white tracking-wide py-1.5 ${
                v.mvpStyle ? "" : ""
              }`}
              style={{ background: "#0a0a0a", fontSize: "13px", lineHeight: 1 }}
            >
              {v.sub}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
